import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ea01c99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reports-page" }
const _hoisted_2 = {
  key: 0,
  class: "reports-page__chart"
}

import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from 'echarts/components';

import VChart, { THEME_KEY } from 'vue-echarts';
import { ref, provide, computed, onMounted } from 'vue';

import DSPageHeader from '@/design-system/DSPageHeader.vue';
import DSEmptyState from '@/design-system/DSEmptyState.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';
import { FETCH_PROJECTS, FETCH_TASKS } from '@/store/types/actions';
import TaskInterface from '@/interfaces/Task.interface';
import formatTimer from '@/hooks/formatTimer';

interface chart_data_interface {
  value: number
  name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ATReports',
  setup(__props) {

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

provide(THEME_KEY, 'dark');

const store = useStore();

const option = ref({});
const tasks = computed(() => store.state.task.tasks);
const projects = computed(() => store.state.project.projects);

onMounted(async () => {
  await Promise.all([
    store.dispatch(FETCH_PROJECTS),
    store.dispatch(FETCH_TASKS),
  ]);

  const chart_data = computed(() => {
    const chart_data_value: chart_data_interface[] = [];

    projects.value.forEach(proj => {
      const total_project_time_spent = tasks.value.reduce((accumulator: number, current_value: TaskInterface) => {
        if (proj.id === current_value.project?.id) {
          return accumulator + (current_value.total_time_spent || current_value.time_spent || 0);
        }

        return accumulator + 0;
      }, 0);

      chart_data_value.push({ value: total_project_time_spent, name: proj.name });
    });

    return chart_data_value;
  });

  option.value = {
    title: {
      text: 'Time by project',
      left: 'center',
      textStyle: {
        fontSize: 18,
        fontWeight: 'bold',
        color: '#1F2937',
      },
    },
    tooltip: {
      trigger: 'item',
      formatter: (
        { seriesName, data: { name, value }, percent }:
        { seriesName: string, data: chart_data_interface, percent: number }
      ) => {
        return `${seriesName} <br/>${name} : ${formatTimer(value)} (${percent}%)`;
      },
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      data: projects.value.map(proj => proj.name),
    },
    series: [
      {
        name: 'Time focused',
        type: 'pie',
        radius: '55%',
        center: ['50%', '60%'],
        data: chart_data.value,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DSPageHeader, {
      title: "Reports",
      subtitle: "Time distribution by project"
    }),
    (projects.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(VChart), {
            class: "reports-page__chart-content",
            option: option.value,
            autoresize: ""
          }, null, 8, ["option"])
        ]))
      : (_openBlock(), _createBlock(DSEmptyState, {
          key: 1,
          title: "No Projects Found",
          message: "Create a project to see reports about your time distribution.",
          icon: "bar_chart"
        }, {
          default: _withCtx(() => [
            _createVNode(DSButton, {
              icon: "folder",
              label: "Go to Projects",
              variant: "primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/projects')))
            })
          ]),
          _: 1
        }))
  ]))
}
}

})